export const options = [
  { value: "auto_split", label: "Auto Split" },
  { value: "manual_split", label: "Manual Split " },
  { value: "consolidated", label: "Consolidated" },
];
